import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addContributionPlaceholder: {
		id: 'polaris-common.plays.add-contribution.add-contribution-placeholder',
		defaultMessage: 'Add your vote',
		description: 'Placeholder for the add vote editor',
	},
});
